"use client";

import type { UseOpenApiQueryOptions } from "@packages/sdk";
import { useOpenApiQuery } from "@packages/sdk";

const urlBackendPath = "/me/related-accounts" as const;

export const keyMeRelatedAccounts = () => ["me-related-accounts"];

export type UseRequestMeRelatedAccountsProps = Omit<
  UseOpenApiQueryOptions<typeof urlBackendPath>,
  "urlBackendPath"
>;

export const useRequestMeRelatedAccounts = ({
  ...props
}: UseRequestMeRelatedAccountsProps = {}) =>
  useOpenApiQuery({
    ...props,
    queryKey: keyMeRelatedAccounts(),
    urlBackendPath,
  });
